import { memo } from 'react'
import { areEqual, ListChildComponentProps } from 'react-window'

import { FieldInfo } from '@/pages/maps/contexts/region-context'

import FieldListItem from '../list-item'

interface RowData {
  items: (FieldInfo & { checked: boolean })[]
  onToggle?: (id: string) => void
  onGoToField: (id: string) => void
}

function FieldListRow({
  data,
  index,
  style,
}: ListChildComponentProps<RowData>) {
  const { items, onToggle, onGoToField } = data
  const field = items[index]

  return (
    <div style={style}>
      <FieldListItem
        field={field}
        onToggle={onToggle}
        onGoToField={onGoToField}
      />
    </div>
  )
}

export default memo(FieldListRow, areEqual)
